<template>
  <!-- Services Section -->
  <section class="services-section" id="services">
    <div class="container">
      <h2 class="section-title">{{ locale === 'tr' ? 'Hizmetlerimiz' : 'Services' }}</h2>
      <p class="section-subtitle">{{ locale === 'tr' ? 'Sürdürülebilir gelecek için yenilenebilir enerji sistemleri' : 'Renewable energy systems for a sustainable future' }}</p>
      <div class="services-grid">
        <div class="service-card" v-for="service in services" :key="service.id">
          <div class="service-icon">{{ service.icon }}</div>
          <h3>{{ service.title }}</h3>
          <p>{{ service.description }}</p>
          <div class="service-features" v-if="service.features && service.features.length > 0">
            <ul>
              <li v-for="(feature, index) in service.features" :key="index">
                {{ locale === 'tr' ? feature.tr : feature.en }}
              </li>
            </ul>
          </div>
          <div class="service-price" v-if="service.price">
            <span class="price-label">{{ locale === 'tr' ? 'Fiyat:' : 'Price:' }}</span>
            <span class="price-value">{{ service.price }}</span>
          </div>
        </div>
      </div>
      
      <!-- Debug info for services -->
      <div v-if="services.length === 0" class="services-debug" style="text-align: center; padding: 20px; background: #f5f5f5; margin: 20px 0;">
        <p>📊 Debug: services.length = {{ services.length }}</p>
        <p>🔄 isLoadingData = {{ isLoadingData }}</p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { useServices } from '@/composables/useServices'

// Props
const props = defineProps({
  locale: {
    type: String,
    default: 'tr'
  }
})

// Computed locale
const locale = computed(() => props.locale)
const localeRef = computed(() => props.locale)

// Composable kullanımı
const { services, isLoadingData } = useServices(localeRef)
</script>